module.exports = __webpack_public_path__ + "img/06.dac40671.jpg";